__turbopack_context__.v({
  "container": "MasterplanList-module__F_oYfW__container",
  "container__item": "MasterplanList-module__F_oYfW__container__item",
});
